import { sendLightCommand } from '@/utils/lightUtils';
import moment from 'moment';

/**
 * 灯光任务数据结构
 */
export interface LightTaskData {
    ip: string;
    port?: number;
    no: string;
    channel_number: number;
    execute_at: number;
    light_status?: number;
}

/** 全局任务队列 */
const taskMap = new Map<string, ReturnType<typeof setTimeout>>();

/**
 * 生成任务唯一ID
 */
const taskId = ({ ip, channel_number, no }: LightTaskData) => `${ip}_${channel_number}_${no}`;

/**
 * 执行关灯指令
 */
const off = ({ ip, no }: LightTaskData) => sendLightCommand(false, { ip, code: no, showToast: false });

/**
 * 清除任务
 */
const clear = (id: string) => {
    const timer = taskMap.get(id);
    if (timer) clearTimeout(timer);
    taskMap.delete(id);
};

/**
 * 添加灯光定时关闭任务
 * @param data 灯光数据，包含 execute_at 指定关闭时间
 */
export const addGlobalLightTask = (data: LightTaskData) => {
    const id = taskId(data);
    clear(id);
    // moment 对象的 valueOf 方法返回的是时间戳（秒数）
    const delay = data.execute_at * 1000 - moment().valueOf();
    if (delay <= 0) return off(data);

    console.log(`[LightTaskQueue] 添加定时任务，${Math.round(delay / 1000)}秒后执行: ${id}`);
    taskMap.set(
        id,
        setTimeout(() => {
            off(data);
            taskMap.delete(id);
            console.log(`[LightTaskQueue] 任务执行完成，已移除: ${id}`);
        }, delay)
    );
};

/**
 * 移除灯光定时任务
 * @param data 灯光数据
 */
export const removeGlobalLightTask = (data: LightTaskData) => clear(taskId(data));

/**
 * 立即执行关灯
 * @param data 灯光数据
 */
export const executeLightOffNow = (data: LightTaskData) => {
    clear(taskId(data));
    off(data);
};

/**
 * 获取所有任务ID
 */
export const getAllGlobalTasks = () => [...taskMap.keys()];

/**
 * 检查任务是否存在
 * @param data 灯光数据
 */
export const hasGlobalLightTask = (data: LightTaskData) => taskMap.has(taskId(data));
